module.exports = __webpack_public_path__ + "886af0627987c79973b83cb8f179d9b4.svg";